/**
 * Workflow Data Service - Refactored
 *
 * Centralized orchestrator for correspondence workflows
 * Now delegates to specialized modules for better separation of concerns
 *
 * REFACTORED FROM 1222 LINES TO ~50 LINES
 *
 * NEW: Added server actions for local environment authentication support
 */

// Import server actions (NEW - preferred for server-side operations)
import {
  getNotificationWorkflowDataAction,
  getCollectionWorkflowDataAction,
  createBulkDraftsAction,
  updateCorrespondenceDraftAction,
  updateCorrespondenceSignatoryAction,
  sendCorrespondencesAction
} from './actions';

// Import URL helpers (not server actions, just helpers)
import {
  getLetterPreviewUrlAction,
  getCollectionDocumentsUrlAction
} from './url-helpers';

// Import client-side functions (kept for backward compatibility)
import {
  getNotificationWorkflowData,
  getCollectionWorkflowData,
  getFollowUpWorkflowData
} from './flows';

import {
  createBulkDrafts,
  createSingleDraft,
  updateDraft,
  updateCorrespondenceSignatory,
  sendCorrespondences,
  getLetterPreviewUrl,
  getCollectionDocumentsUrl
} from './services/correspondence.service';

import { prefetchLetterhead } from './services/letterhead.service';

/**
 * WorkflowDataService - Main orchestrator class
 *
 * Acts as a facade for all workflow-related operations,
 * delegating to specialized services and modules
 *
 * Server actions are now available to fix local authentication issues
 */
export class WorkflowDataService {
  // Server Actions (NEW - use these for server-side operations)
  static getNotificationWorkflowDataAction = getNotificationWorkflowDataAction;
  static getCollectionWorkflowDataAction = getCollectionWorkflowDataAction;
  static createBulkDraftsAction = createBulkDraftsAction;
  static updateDraftAction = updateCorrespondenceDraftAction;
  static updateCorrespondenceSignatoryAction =
    updateCorrespondenceSignatoryAction;
  static sendCorrespondencesAction = sendCorrespondencesAction;
  static getLetterPreviewUrlAction = getLetterPreviewUrlAction;
  static getCollectionDocumentsUrlAction = getCollectionDocumentsUrlAction;

  // Client-side functions (kept for backward compatibility)
  static getNotificationWorkflowData = getNotificationWorkflowData;
  static getCollectionWorkflowData = getCollectionWorkflowData;
  static getFollowUpWorkflowData = getFollowUpWorkflowData;
  static createBulkDrafts = createBulkDrafts;
  static createSingleDraft = createSingleDraft;
  static updateDraft = updateDraft;
  static updateCorrespondenceSignatory = updateCorrespondenceSignatory;
  static sendCorrespondences = sendCorrespondences;

  // URL generation
  static getLetterPreviewUrl = getLetterPreviewUrl;
  static getCollectionDocumentsUrl = getCollectionDocumentsUrl;

  // Letterhead management
  static prefetchLetterhead = prefetchLetterhead;
}

export default WorkflowDataService;
